import React, { useState } from 'react';

import StepIndicator from '../components/StepIndicator';

import Step1Download from '../components/steps/Step1Download';
import Step2Upload from '../components/steps/Step2Upload';
import useWorkflow from 'hooks/useWorkflow';
import Step3Reprocess from '../components/steps/Step3Reprocess';
import DPSAReprocessingTabs from 'components/DPSAReprocessingTabs';

const Index = () => {
  const [isComplete, setIsComplete] = useState(false);
  
  const {
    currentStep,
    steps,
    nextStep,
    resetWorkflow,
    isLastStep,
    goToStep 
  } = useWorkflow([
    'Download Template',
    'PRE Processing phase',
    'POST Processing phase'
  ]);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1Download 
          onComplete={nextStep} 
          templateUrl="" 
        />;
      case 2:
        return <DPSAReprocessingTabs step="pre" disableHistoryTab={false} />
      case 3:
        return <DPSAReprocessingTabs step="post" disableHistoryTab={false} />
      default:
        return null;
    }
  };

  const handleReset = () => {
    setIsComplete(false);
    resetWorkflow();
  };

  // Manejador para clicks en los steps
  const handleStepClick = (stepNumber: number) => {
    goToStep(stepNumber);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br  flex items-center justify-center p-4">
      <div className="w-full max-w-5xl bg-white rounded-xl shadow-lg p-6 md:p-8">
        <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
        DPSA Reprocessing Tool
        </h1>
        
        {!isComplete ? (
          <>
            <StepIndicator 
              currentStep={currentStep} 
              steps={steps} 
              onStepClick={handleStepClick}
            
            />
            <div className="transition-all duration-300 ease-in-out">
              {renderCurrentStep()}
            </div>
          </>
        ) : (
          <div className="py-8 text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Process Complete!</h2>
            <p className="text-gray-600 mb-6">
              Your Excel file has been successfully processed. All data has been imported into the system.
            </p>
            <button
              onClick={handleReset}
              className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200"
            >
              Start a New Process
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;